// extracted by mini-css-extract-plugin
export default {"break-word":"BridgeRecord_break-word__4D5RJ"};